export const SET_UNREAD_COUNT = 'SET_UNREAD_COUNT'
export const INCREMENT_UNREAD_COUNT = 'INCREMENT_UNREAD_COUNT'
export const DECREMENT_UNREAD_COUNT = 'DECREMENT_UNREAD_COUNT'
export const RESET_UNREAD_COUNT = 'RESET_UNREAD_COUNT'
